// @flow

import React from 'react'

type Props = {
  children?: React$Node,
}

const PageOverlay = ({ children }: Props) => {
  return (
    <div className="fixed top-0 right-0 bottom-0 left-0 pa5 bg-black-50 flex items-center justify-center z-999">
      {children}
    </div>
  )
}

export default PageOverlay



// WEBPACK FOOTER //
// ./src/components/Controls/PageOverlay.js